module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-9"
  }, [_c('div', {
    staticClass: "new_soproni_small_area"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('data-view', {
    attrs: {
      "data": _vm.wrapper.invoicingData
    }
  }), _vm._v(" "), _c('section', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "ked_menu_box"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.wrapper.sameInvoicingShipping),
      expression: "wrapper.sameInvoicingShipping"
    }],
    staticClass: "cb-shipping",
    attrs: {
      "type": "checkbox",
      "placeholder": ""
    },
    domProps: {
      "checked": Array.isArray(_vm.wrapper.sameInvoicingShipping) ? _vm._i(_vm.wrapper.sameInvoicingShipping, null) > -1 : (_vm.wrapper.sameInvoicingShipping)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.wrapper.sameInvoicingShipping,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.wrapper.sameInvoicingShipping = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.wrapper.sameInvoicingShipping = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.wrapper, "sameInvoicingShipping", $$c)
        }
      }
    }
  })])])])])]), _vm._v(" "), (!_vm.wrapper.sameInvoicingShipping) ? _c('data-view', {
    attrs: {
      "data": _vm.wrapper.shippingData
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "kedvenciam_all_area for_nw_form"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "single_kedvenciam_all",
    staticStyle: {
      "padding-left": "0",
      "padding-right": "0"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "thm_last_btn text-center no-margin"
  }, [_c('a', {
    on: {
      "click": _vm.save
    }
  }, [_vm._v("VÁLTOZTATÁSOK MENTÉSE")])])])])])])])])], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "section_title_box"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "section_title"
  }, [_c('div', {
    staticClass: "section_title_cont text-left"
  }, [_c('h3', [_vm._v("SZEMÉLYES ADATOK")])])])])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "ked_menu_box"
  }, [_c('div', {
    staticClass: "ked_menu_box_cont"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "szem_title"
  }, [_c('p', [_vm._v("SZÁMLÁZÁSI ADATOK")])])])])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ked_menu_box_cont"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "szem_title"
  }, [_c('p', [_vm._v("SZÁLLÍTÁSI ADATOK")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-9"
  }, [_c('div', {
    staticClass: "vezteknev_title"
  }, [_c('h6', [_vm._v("Szállítási adatok megegyeznek a számlázási adatokkal")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-77314d5e","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/main/components/pages/dashboard/profile/Profile.vue
// module id = 120
// module chunks = 0 1 2